import type { VisualModule, VisualSample } from './types';
type Particle={x:number;y:number;vx:number;vy:number;life:number;size:number;hue:number};

export class ParticleVisual implements VisualModule {
  private particles:Particle[]=[];
  draw(ctx:CanvasRenderingContext2D,w:number,h:number,s:VisualSample){
    if(!s.frozen){
      const hands=[{p:s.left,speed:s.movement.leftHandSpeed,h:188},{p:s.right,speed:s.movement.rightHandSpeed,h:325}];
      for(const hand of hands){
        if(!hand.p) continue;
        const count=s.reducedMotion?1:Math.floor(1+hand.speed*7+s.movement.movementEnergy*4);
        for(let i=0;i<count;i++) this.particles.push({x:hand.p.x*w,y:hand.p.y*h,vx:(Math.random()-.5)*(2+hand.speed*12),vy:(Math.random()-.5)*(2+hand.speed*12),life:1,size:3+Math.random()*9*(.3+hand.speed),hue:hand.h+Math.random()*30-15});
      }
    }
    const cap=s.reducedMotion?120:320; this.particles=this.particles.slice(-cap);
    ctx.save();
    this.particles=this.particles.filter(p=>p.life>.02);
    for(const p of this.particles){p.x+=p.vx;p.y+=p.vy;p.vx*=.98;p.vy=p.vy*.98+.025;p.life*=.965;ctx.globalAlpha=p.life;ctx.fillStyle=`hsl(${p.hue} 100% 72%)`;ctx.shadowColor=ctx.fillStyle;ctx.shadowBlur=10;ctx.beginPath();ctx.arc(p.x,p.y,p.size*p.life,0,Math.PI*2);ctx.fill();}
    ctx.restore();
  }
  clear(){this.particles=[];}
}
